module.exports = __webpack_public_path__ + "static/assets/6b6e8b2e6b9b9067aaeaf63e7677393b.svg";